// extracted by mini-css-extract-plugin
export var cardIcon = "_n-5";
export var cardIconUnframed = "_n-9";
export var checkboxCard = "_n-0";
export var checkboxCardSelected = "_n-4";
export var disabled = "_n-2";
export var interactive = "_n-1";
export var outerBorder = "_n-3";
export var spacerMedium = "_n-8";
export var spacerSmall = "_n-7";
export var spacerXsmall = "_n-6";